export default __webpack_public_path__ + "static/media/air.ad980ae9.jpeg";